var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 4.00002C14.6666 3.26669 14.0666 2.66669 13.3333 2.66669H2.66659C1.93325 2.66669 1.33325 3.26669 1.33325 4.00002V12C1.33325 12.7334 1.93325 13.3334 2.66659 13.3334H13.3333C14.0666 13.3334 14.6666 12.7334 14.6666 12V4.00002ZM13.3333 4.00002L7.99992 7.33335L2.66659 4.00002H13.3333ZM13.3333 12H2.66659V5.33335L7.99992 8.66669L13.3333 5.33335V12Z",
    fill: "#18A0D7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailOutline);
export default __webpack_public_path__ + "static/media/EmailOutline.20014b2852bbee6f517dd35e075a5170.svg";
export { ForwardRef as ReactComponent };